import { render, staticRenderFns } from "./ActionItem.vue?vue&type=template&id=d34f7f1a&scoped=true&"
import script from "./ActionItem.vue?vue&type=script&lang=js&"
export * from "./ActionItem.vue?vue&type=script&lang=js&"
import style0 from "./ActionItem.vue?vue&type=style&index=0&id=d34f7f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34f7f1a",
  null
  
)

export default component.exports